/**
 * PO (B2B) revenue on the Sales overview: the value of what was shipped against POs dated in the period. It is on its own
 * line because it is never part of revenue (for Amazon Vendor, revenue is sell-through). Hidden when nothing was shipped,
 * and when the page is filtered: it has no brand or platform split, so it would not match the numbers beside it.
 */
import React from 'react';
import { useCountry } from '../../contexts/CountryContext';
import { number, shortMoney } from './format';
import { queryString, useAbortableGet } from './useAbortableGet';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export const PoRevenueStrip = ({ scope }) => {
  const { country } = useCountry();
  const filtered = (scope.platform && scope.platform !== 'ALL') || (scope.brand && scope.brand !== 'ALL')
    || (scope.category && scope.category !== 'ALL') || scope.sku || scope.search;
  const { data, loading, error } = useAbortableGet(filtered ? null : `${API}/sales/po-revenue?${queryString({ date_from: scope.date_from, date_to: scope.date_to, country })}`);
  const orders = data?.b2b_orders;
  if (filtered || loading || error || !data || (!data.shipped_units && !orders?.units)) return null;   // never a previous period's figure
  return (
    <p className="rounded-xl border border-gray-200 bg-white px-4 py-2 text-[13px] text-gray-700" title={data.basis} data-testid="po-revenue-strip">
      {data.shipped_units > 0 && (
        <>
          <span className="font-medium text-gray-900">PO revenue (B2B): {shortMoney(data.shipped_value)}</span>
          {' · '}{number(data.shipped_units)} units shipped on {number(data.shipped_pos)} PO{data.shipped_pos === 1 ? '' : 's'}.{' '}
        </>
      )}
      {orders?.units > 0 && (
        <span data-testid="b2b-revenue">
          <span className="font-medium text-gray-900">B2B orders: {shortMoney(orders.value)}</span>
          {' · '}{number(orders.units)} units on {number(orders.orders)} order{orders.orders === 1 ? '' : 's'}.{' '}
        </span>
      )}
      <span className="text-gray-500">Excl. GST, and not included in the revenue above.</span>
      {data.unpriced_units > 0 && <span className="text-amber-800"> {number(data.unpriced_units)} shipped units have no cost on the PO.</span>}
    </p>
  );
};

export default PoRevenueStrip;
